'use client'
import {CircularProgressbar} from 'react-circular-progressbar'
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from 'react-share'
import emailImg from 'assets/icons/common/email-share.svg'
import linkedinImg from 'assets/icons/common/linkedin-share.svg'
import facebookImg from 'assets/icons/common/facebook-share.svg'
import twitterImg from 'assets/icons/common/twitter-share.svg'
import 'react-circular-progressbar/dist/styles.css'
import classes from './styles.module.css'
import Image from 'next/image'
import {useEffect, useState} from 'react'

const ProgressBar = ({percentage}: {percentage: any}) => {
  // Initialize state to store the URL
  const [currentUrl, setCurrentUrl] = useState('')

  // Set the URL after component mounts in the browser
  useEffect(() => {
    setCurrentUrl(window.location.href)
  }, [])

  const shareData = [
    {name: 'email', Button: EmailShareButton, icon: emailImg},
    {
      name: 'facebook',
      Button: FacebookShareButton,
      icon: facebookImg,
    },
    {
      name: 'twitter',
      Button: TwitterShareButton,
      icon: twitterImg,
    },
    {
      name: 'linkedin',
      Button: LinkedinShareButton,
      icon: linkedinImg,
    },
  ]

  return (
    <div className={classes.progressbar}>
      <CircularProgressbar
        value={percentage}
        text={`${percentage}%`}
        styles={{
          // Customize the path, i.e. the "completed progress"
          path: {
            stroke: '#254DDA',
            strokeLinecap: 'butt',
          },
          // Customize the circle behind the path, i.e. the "total progress"
          trail: {
            stroke: '#E2DEF6',
            strokeWidth: '3',
          },
          // text property
          text: {
            fontSize: '16px',
            fill: 'black',
          },
        }}
      />
      <div className={classes.shareSection}>
        <div className={classes.singleLinkWrapper}>
          {currentUrl &&
            shareData.map((data, idx) => (
              <div className={classes.singleLink} key={idx}>
                <data.Button url={currentUrl} key={data.name}>
                  <Image height={30} width={30} src={data.icon} alt="share" />
                </data.Button>
              </div>
            ))}
        </div>
      </div>
    </div>
  )
}

export default ProgressBar
